import { toast } from "react-toastify";

const baseURL = process.env.React_App_Base_Url_Api;

export const Get = (Url, token, data) => {
	return new Promise(async (resolve, reject) => {
		try {            
			const response = await fetch(data ? `${baseURL}${Url}?${data}` : `${baseURL}${Url}`, {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
                    'Authorization': token ? token : '',
				},
				method: 'GET',
			}).then((res) => res.json());
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		} catch (error) {
			toast.error(error.mesage)
			console.log(error);
		}
	});
};

export const Post = (Url, token, data) => {
	return new Promise(async (resolve, reject) => {
		try {            
			const response = await fetch(`${baseURL}${Url}`, {
				body: data ? JSON.stringify(data) : '',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
                    'Authorization': token ? token : '',
				},
				method: 'POST',
			}).then((res) => res.json());
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		} catch (error) {
			toast.error(error.mesage)
			console.log(error);
		}
	});
};

export const Put = (Url, data)  => {
	return new Promise(async (resolve, reject) => {
		try {            
			const response = await fetch(`${baseURL}${Url}`, {
				body: data ? JSON.stringify(data) : '',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				method: 'PUT',
			}).then((res) => res.json());
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		} catch (error) {
			toast.error(error.mesage)
			console.log(error);
		}
	});
};

export const Delete = (Url, token, data) => {
	return new Promise(async (resolve, reject) => {
		try {            
			const response = await fetch(`${baseURL}${Url}`, {
				body: data ? JSON.stringify(data) : '',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
                    'Authorization': token ? token : '',
				},
				method: 'DELETE',
			}).then((res) => res.json());
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		} catch (error) {
			toast.error(error.mesage)
			console.log(error);
		}
	});
};